import React from 'react';
import { BookOpenIcon, ListChecksIcon, UsersIcon, XIcon, CheckIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
const steps = [{
  icon: BookOpenIcon,
  title: 'Open',
  body: 'Access the library.'
}, {
  icon: ListChecksIcon,
  title: 'Choose',
  body: 'Pick the class that fits what you want to teach.'
}, {
  icon: UsersIcon,
  title: 'Teach',
  body: 'Review the structure, adapt where needed and walk into class prepared.'
}];
const notThis = ['Not a random pose library.', 'Not a list of sequence ideas you still need to finish.', 'Not a theory-heavy ebook you have to turn into a class yourself.'];
export function SolutionSection() {
  return <section className="w-full bg-cream py-10 sm:py-14 lg:py-20" aria-labelledby="solution-heading" data-id="element-179" data-mp="5wcdymnapkx2">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-180" data-mp="ktmzkotnk76i">
        <div className="mx-auto max-w-2xl text-center" data-id="element-181" data-mp="ftqu0l5b47ou">
          <div className="flex justify-center" data-id="element-182" data-mp="fv1v2d7db1c9">
            <SectionLabel data-id="element-183" data-mp="36avuhb5b57a6">The system</SectionLabel>
          </div>
          <h2 id="solution-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ink sm:text-4xl" data-id="element-184" data-mp="36cp2ouvkjzka">
            What if your classes were already planned?
          </h2>

          <div className="mx-auto mt-5 max-w-sm rounded-2xl border border-gold/30 bg-ivory px-5 py-4" data-id="element-185" data-mp="3kancdmyy37tg">
            <p className="text-[0.55rem] font-semibold uppercase tracking-label text-gold" data-id="element-186" data-mp="3pa9p7vav2m1q">
              Introducing
            </p>
            <p className="mt-1 font-serif text-[1.05rem] font-semibold uppercase leading-tight text-ink sm:text-xl" data-id="element-187" data-mp="3u6qeistsr6ge">
              Yoga Teacher System™
            </p>
            <p className="mt-2 text-[0.72rem] font-semibold uppercase leading-relaxed tracking-label text-forest" data-id="element-188" data-mp="6uflvkjgccbq">
              120 complete Ready-to-Teach classes
              <span className="block text-muted" data-id="element-189" data-mp="gtofudebhqy3">6 professional volumes</span>
            </p>
          </div>
        </div>

        <ol className="mt-7 grid gap-2.5 sm:grid-cols-3 sm:gap-4" data-id="element-190" data-mp="2cw1j33a5tbrv">
          {steps.map(({
          icon: Icon,
          title,
          body
        }, index) => <li key={title} className="flex h-full flex-col items-center gap-2 rounded-2xl border border-sandDark bg-ivory px-4 py-4 text-center" data-id="element-191" data-mp="27zb5qnpqoua5" data-mpi={index}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-cream" data-id="element-192" data-mp="2hv4dzuwfe1m4">
                <Icon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-193" data-mp="2vlzp7duecusv" />
              </span>
              <span className="font-serif text-sm font-semibold uppercase tracking-label text-ink" data-id="element-194" data-mp="2rknzz9ffqbl7">
                {index + 1}. {title}
              </span>
              <span className="text-[0.8rem] leading-snug text-muted sm:text-[0.88rem]" data-id="element-195" data-mp="30mdwgto6c0pu">
                {body}
              </span>
            </li>)}
        </ol>

        <p className="mt-5 text-center font-serif text-sm uppercase tracking-label text-forest sm:text-base" data-id="element-196" data-mp="1b9jxzmsftame">
          Open <span className="text-gold" data-id="element-197" data-mp="3hvpzmpbmlhea">•</span> Choose <span className="text-gold" data-id="element-198" data-mp="3hwrd10g46fz6">•</span>{' '}
          Teach
        </p>

        <div className="mt-9 rounded-3xl border border-sandDark bg-ivory p-5 sm:p-7" data-id="element-199" data-mp="3mvcbaubt2pkz">
          <h3 className="text-center font-serif text-[1.15rem] font-semibold uppercase leading-tight text-ink sm:text-2xl" data-id="element-200" data-mp="3866f7f89lfhb">
            Not another collection of yoga ideas.
          </h3>
          <ul className="mx-auto mt-4 grid max-w-2xl gap-2 sm:grid-cols-3" data-id="element-201" data-mp="2z588uqacsvvk">
            {notThis.map(line => <li key={line} className="flex h-full flex-col items-center gap-1.5 rounded-2xl bg-cream/70 px-3 py-3 text-center" data-id="element-202" data-mp="3441lyhlqakv7">
                <XIcon className="h-3.5 w-3.5 shrink-0 text-clay" aria-hidden="true" data-id="element-203" data-mp="2p9exha8df8fd" />
                <span className="text-[0.78rem] leading-snug text-muted" data-id="element-204" data-mp="2u885in4w2785">{line}</span>
              </li>)}
          </ul>
          <div className="mx-auto mt-4 flex max-w-md flex-col items-center gap-2 rounded-2xl bg-forest px-4 py-4 text-center" data-id="element-205" data-mp="seio40fxmh6f">
            <CheckIcon className="h-4 w-4 text-goldSoft" aria-hidden="true" data-id="element-206" data-mp="2ogvngf8nlhux" />
            <p className="font-serif text-[0.95rem] font-semibold uppercase leading-tight text-ivory sm:text-lg" data-id="element-207" data-mp="2kfsduah78i25">
              These are complete Ready-to-Teach class plans.
            </p>
            <p className="text-[0.72rem] uppercase tracking-label text-ivory/70" data-id="element-208" data-mp="2aie3mslvcpia">
              The structure is already there. You bring the teaching.
            </p>
          </div>
        </div>
      </div>
    </section>;
}